export default "__VITE_ASSET__4VPJx490__"